module.exports = __webpack_public_path__ + "img/assessment-active.8d68008b.svg";